// extracted by mini-css-extract-plugin
export default {"container":"DdMGrFSO","skeleton":"Okl8KPEA"};